export default function () {
  return {
    employees: [],
    employee: {},
    positions: [],
    listPosition: [],
    position: {},
    employeeTableSort: {
      sortBy: 'created_at',
      sortDesc: true
    },
    divisions: [],
    division: {}
  }
}
